import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import Loader from '../components/loader/Loader';

interface LoaderContextType {
  loading: boolean;
  showLoader: () => void;
  hideLoader: () => void;
}

const LoaderContext = createContext<LoaderContextType>({
  loading: false,
  showLoader: () => {},
  hideLoader: () => {},
});

let showLoaderCallback = () => {};
let hideLoaderCallback = () => {};

export const useLoader = (): LoaderContextType => useContext(LoaderContext);

interface LoaderProviderProps {
  children: ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [pendingRequests, setPendingRequests] = useState(0);
  const loading = pendingRequests > 0;

  useEffect(() => {
    showLoaderCallback = () => setPendingRequests((prev) => prev + 1);
    hideLoaderCallback = () => setPendingRequests((prev) => Math.max(0, prev - 1));

    return () => {
      showLoaderCallback = () => {};
      hideLoaderCallback = () => {};
    };
  }, []);

  const showLoader = () => setPendingRequests((prev) => prev + 1);
  const hideLoader = () => setPendingRequests((prev) => Math.max(0, prev - 1));

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      <Loader />
    </LoaderContext.Provider>
  );
};

export const showLoader = () => showLoaderCallback();
export const hideLoader = () => hideLoaderCallback();
